/**
 * IMPORTS
 */

import { useMutation } from "@tanstack/react-query";

// typings
import { ILiberarRemessaPayload, ILiberarRemessaResponse } from "@/hooks/liberar-remessa/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

// domain / caso de usos
import { handleLiberarRemessa } from "@/domain/use-cases/liberar-remessa";
// utils
import { notifyAlert, notifySuccess } from "@/utils/notify-messages";

export function useLiberarRemessaBalcao() {
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<ILiberarRemessaResponse, Error, ILiberarRemessaPayload>({
    mutationFn: async (payload) => {
      return await handleLiberarRemessa(token!, payload);
    },
    onSuccess: async ({ data, message }) => {
      if (!data) {
        notifyAlert(message);
        return;
      }

      notifySuccess("Remessa liberada com sucesso!");
    },
    onError: async () => {
      notifySuccess("Houve um problema ao tentar liberar a remessa!");
    },
  });

  return {
    liberarRemessa: mutation.mutate, // chamada direta
    liberarRemessaAsync: mutation.mutateAsync, // se quiser await
    isLoadingLiberarRemessa: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
